import React from "react";
import PropTypes from "prop-types";

import { StoryCard } from "../basic/story-card.js";
import { StoryList } from "../basic/story-list.js";
import { AdService } from "../ad-service";

function OneStoryCardSixStoryList(props) {
  const majorStoryCardWithSubheadlineConfig = {
    image: true,
    subheadline: true,
    imageAspectRatio: [16, 9]
  };

  if (props.stories.length < 1) {
    return <div />;
  }

  return (
    <div className="onestorycard-sixstorylist component-wrapper">
      <StoryCard hideSectionName={true} story={props.stories[0]} config={majorStoryCardWithSubheadlineConfig} />
      <StoryList stories={[props.stories[1], props.stories[2], props.stories[3]]} />
      <StoryList stories={[props.stories[4], props.stories[5], props.stories[6]]} />
      <div className="app-ad app-ad--horizontal app-ad--grid-horizontal">
        <AdService
          adtype="Horizontal-Ad"
          layoutName="OneStoryCardSixStoryList"
          collectionSlug={props.config["collection-slug"]}
          slotId={`OneStoryCardSixStoryList-${props.index}`}
        />
      </div>
    </div>
  );
}

OneStoryCardSixStoryList.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export { OneStoryCardSixStoryList };
